module.exports = __webpack_public_path__ + "img/frame (128).22a43c7b.jpg";